import { View } from "binder"
import { FloatViewModel } from "./float-viewModel"

export class FloatView extends View<FloatViewModel>{
    GetViewUniqueId(): string {
        return "V-3379477F-2466-4C3A-AA83-80BC25893CAB"
    }
    loadHtml(): string {
        let element = require('./float.html').default;
        let style = require('./float.less');
        return element;
    }
    constructor() {
       super();
    }
    public set value(v: number) { this._value = v; } public get value(): number { return this._value;} private _value: number;

}
